import { Action, ActionType } from "models/stressCheck/newStressCheck";
import { IResponse } from "models";

import createReducer from "redux/createReducer";

export interface NewStressCheckReducerType {
  loading: boolean;
  error?: any;
  saved: boolean;
  newStressCheckResponse?: IResponse;
}

const defaultState: NewStressCheckReducerType = {
  loading: false,
  error: null,
  saved: false,
  newStressCheckResponse: undefined,
};

export const newStressCheckReducer = createReducer<NewStressCheckReducerType>(
  defaultState,
  {
    [ActionType.NEW_STRESS_CHECK](state: NewStressCheckReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.NEW_STRESS_CHECK_ERROR](
      state: NewStressCheckReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        saved: false,
        error: action.payload,
      };
    },

    [ActionType.NEW_STRESS_CHECK_SUCCESS](
      state: NewStressCheckReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        saved: true,
        newStressCheckResponse: action.payload,
      };
    },

    [ActionType.RESET_NEW_STRESS_CHECK](state: NewStressCheckReducerType) {
      return {
        ...state,
        loading: false,
        saved: false,
        error: null,
        newStressCheckResponse: undefined,
      };
    },
  }
);
